import React, { useContext, useState } from 'react';
import PizZip from 'pizzip';
import Docxtemplater from 'docxtemplater';
import ImageModule from 'docxtemplater-image-module-free';
import saveAs from 'file-saver';
import extenso from 'extenso';
import Notificacao from './Notificacao'
import Context from '../../../Context/Context';
import axios from '../../axios/axios'





const Input = ({ name, formData, label, handleChangeFormData, setFormData }) => {
  const isDate = name.toLowerCase().includes("data");
  const { indicacao } = useContext(Context)

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const getProcesso = () => {
    if (formData?.Processo?.length == 25) {
      const keys = Object.keys(formData || {});
      const convert = {};
      const found = indicacao.find(
        (ind) => ind?.processo?.trim() === formData?.Processo?.trim(),
      );
      Object.keys(found || {}).forEach((e) => {
        if (keys.includes(capitalizeFirstLetter(e))) {
          if (e != "status") {
            convert[capitalizeFirstLetter(e)] = found[e];
          }
        }
      });
      if (found) {
        // setFoundIndicacao(found)
        setFormData({ ...formData, ...convert });
      }
    }
  }

  
  

  return (
    <div className="relative w-full">

      {name == 'Processo' ? (
        <input
          type={isDate ? "date" : "text"}
          id={name == 'Processo'}
          value={formData[name]}
          onBlur={getProcesso}
          onChange={(e) => handleChangeFormData(name, e.target.value)}
          className="peer w-full rounded-xl border bg-white px-4 pt-6 pb-2 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed "
        />
      ) : (
        <input
          id={name}
          type={isDate ? "date" : "text"}
          value={formData[name]}
          onChange={(e) => handleChangeFormData(name, e.target.value)}
          className="peer w-full rounded-xl border bg-white !px-4 !pt-5 !pb-2 text-gray-900
        focus:outline-none focus:ring-2 focus:ring-blue-500
        disabled:bg-gray-100 disabled:cursor-not-allowed"
          placeholder=" " // necessário para o label flutuante
        />
      )}

      <label
        htmlFor={name}
        className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
          peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
          peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500 text-overflow: ellipsis sm:truncate overflow-hidden whitespace-nowrap w-48"
      >
        {label || name.replaceAll("_", " ")}
      </label>





    </div>
  );
};

export default function RelatorioRural() {

  const [formData, setFormData] = useState({
    Período: '',
    Exequente_1: '',
    Data: '',
    Matrícula: '',
    Cartório: '',
    Contribuinte: '',
    Mês: '',
    Metragem_utilizada: '',
    Tipo_de_Área_Usada: '',
    Certidão_de_Matrícula: '',
    Data_Base_do_Google_Maps: '',
    Detalhamento_Regional: '',
    Documento_da_Metragem: '',

  });

  const [formData2, setFormData2] = useState({
    Valor_m_1: '', Valor_m_2: '', Valor_m_3: '', Valor_m_4: '', Valor_m_5: '', valor_m2: "",
    Valor_Media_m: '', Valor_do_Imovel: '',
    Link_do_comparativo1: '', Link_do_comparativo2: '', Link_do_comparativo3: '', Link_do_comparativo4: '', Link_do_comparativo5: '',
    M_do_Imóvel: "", Extenso_Média_1: '', Extenso_Média_2: '', Extenso_Média_3: '', Extenso_Média_4: '', Extenso_Média_5: '', Extenso_Media_Total: '',
    Extenso_Valor_Imóvel: '',
  });

  const [mostrarNotificacao, setMostrarNotificacao] = useState(false);
  const [numImoveis, setNumImoveis] = useState(3);
  const [valoresImoveis, setValoresImoveis] = useState(['', '', '']);
  const [hectares, setHectares] = useState(['', '', '']);
  const [linkComparativo, setLinkComparativo] = useState(["", "", ""])
  const [metrosImovelAvaliado, setMetrosImovelAvaliado] = useState('');
  const [seçãoAtual, setSeçãoAtual] = useState(1);
  const { solicitacaoAndamentoId, setSolicitacaoAndamentoId, usuario } = useContext(Context)
  const [confirmarLimpeza, setConfirmarLimpeza] = useState(false); // definir no começo






  const limparSelecionados = () => {
    setFormData((prev) => ({
      ...prev,
      Matrícula: '',
      Endereco: ''
    }))
  }

  const limparTudo = () => {
    setFormData({
      Período: '',
      Exequente_1: '',
      Data: '',
      Matrícula: '',
      Cartório: '',
      Contribuinte: '',
      Mês: '',
      Metragem_utilizada: '',
      Tipo_de_Área_Usada: '',
      Certidão_de_Matrícula: '',
      Data_Base_do_Google_Maps: '',
      Detalhamento_Regional: '',
      Documento_da_Metragem: ''
    })

    setFormData2({
      Valor_m_1: '', Valor_m_2: '', Valor_m_3: '', Valor_m_4: '', Valor_m_5: '', valor_m2: "",
      Valor_Media_m: '', Valor_do_Imovel: '',
      Link_do_comparativo1: '', Link_do_comparativo2: '', Link_do_comparativo3: '', Link_do_comparativo4: '', Link_do_comparativo5: '',
      M_do_Imóvel: "", Extenso_Média_1: '', Extenso_Média_2: '', Extenso_Média_3: '', Extenso_Média_4: '', Extenso_Média_5: '', Extenso_Media_Total: '',
      Extenso_Valor_Imóvel: '',
    })
    setNumImoveis(3)
    setValoresImoveis(["", "", ""])
    setHectares(["", "", ""])
    setLinkComparativo(["", "", ""])
    setMetrosImovelAvaliado('')
  }

  const camposPorSeção = {
    1: ['Período', 'Exequente_1', 'Data', 'Matrícula'],
    2: ['Cartório', 'Contribuinte', ],
    3: ['Metragem_utilizada', 'Certidão_de_Matrícula', 'Data_Base_do_Google_Maps', 'Documento_da_Metragem'],

  };
  const labels = {
    Data: 'Data da Solicitação',
    Certidão_de_Matrícula: 'Descrição do bem',
    Metragem_utilizada: 'Em qual documento consta a metragem utilizado'


  }



  const formatarDataRobusta = (dataString) => {
    const data = new Date(dataString);
    if (isNaN(data)) return "";
    return new Intl.DateTimeFormat("pt-BR").format(data); // Retorna "22/05/2025"
  };

  const novoFormData = { ...formData };

  Object.keys(novoFormData).forEach((chave) => {
    if (chave.toLowerCase().includes("data") && novoFormData[chave]) {
      novoFormData[chave] = formatarDataRobusta(novoFormData[chave]);
    }
  });





  const totalSeções = 4;

  const handleChangeFormData = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const salvarContribuinte = async () => {
      if(formData.Contribuinte) {
        try {
          await axios.post('/avaliacao/relatorio', {
            processo: formData.Processo,
            inscricao_municipal: formData.Contribuinte
          })      
        } catch (error) {
         console.log(error, 'Erro ago salvar dados do relatório.') 
        }
      }
    }

  const handleValorImovelChange = (index, value) => {
    const updatedValores = [...valoresImoveis];
    updatedValores[index] = value;
    setValoresImoveis(updatedValores);
  };

  const handleMetrosQuadradosChange = (index, value) => {
    const updatedMetros = [...hectares];
    updatedMetros[index] = value;
    setHectares(updatedMetros);
  };

  const handleLinkComparativoChange = (index, value) => {
    const updatedLinks = [...linkComparativo];
    updatedLinks[index] = value;
    setLinkComparativo(updatedLinks);
  };



  const calcularValoresMetroQuadrado = () => {
    const resultados = [];
    let somaTotal = 0;

    for (let i = 0; i < numImoveis; i++) {
      const valorImovel = Number(valoresImoveis[i]?.trim() || '0');
      const metros = Number(hectares[i]?.trim() || '0');
      const link = linkComparativo[i]?.trim() || '';
      formData2[`Link_do_comparativo${i + 1}`] = link;
      if (!isNaN(valorImovel) && !isNaN(metros) && metros !== 0) {
        const valorMetro = valorImovel / metros; // valor numérico
        resultados.push(valorMetro);

        const media = valorMetro.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });

        formData2[`Valor_m_${i + 1}`] = media;



        somaTotal += valorMetro;

        formData2[`Extenso_Média_${i + 1}`] = extenso(valorMetro, { mode: 'currency' });
      } else {
        resultados.push(0);
      }
    }

    const mediaTotal = somaTotal / numImoveis;
    const metrosAvaliado = parseFloat(metrosImovelAvaliado.trim() || '0');

    const numero = 1234.56;
    const porExtenso = extenso(numero, { mode: 'currency' });

    formData2.Extenso_Media_Total = extenso(Number(mediaTotal), { mode: 'currency' });
    formData2.Valor_Media_m = mediaTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    const valorDoImovel = metrosAvaliado * mediaTotal;
    formData2.M_do_Imóvel = metrosAvaliado
    formData2.Valor_do_Imovel = valorDoImovel.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    formData2.Valor_m2 = (mediaTotal - mediaTotal * 0.02).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    formData2.Extenso_Valor_Imóvel = extenso(Number(valorDoImovel), { mode: 'currency' });


    if (!isNaN(metrosAvaliado) && metrosAvaliado !== 0) {
      resultados.push(mediaTotal);
    }

    return resultados;
  };

  const gerarDocumento = async () => {
    // if (!usuario.role.includes('Avaliação') && !usuario.role.includes('Supervisor')) {
    //   return alert('Você deve ser de avaliação para emitir relátorios') //perguntar se é so de avaliação que pode emitit relatorios
    // }
    if (solicitacaoAndamentoId) {
      await axios.put('/solicitacao/captacao/avaliacao/' + solicitacaoAndamentoId, {
        status: 'Correção'

      }, {
        headers: { Authorization: usuario.token }
      })
    }
    setSolicitacaoAndamentoId(null)
    const valoresMetroQuadrado = calcularValoresMetroQuadrado();
    const chartConfig = {
      type: 'bar',
      data: {
        labels: [...Array.from({ length: numImoveis }, (_, i) => `Comparativo ${i + 1}`), 'Imóvel Avaliando'],
        datasets: [{
          label: 'Valor Médio por m²',
          data: valoresMetroQuadrado,
          backgroundColor: [...Array(numImoveis).fill('#C0C0C0'), '#000000'],
        }]
      }
    };

    
    
    const quickChartUrl = `https://quickchart.io/chart?width=600&height=400&c=${encodeURIComponent(JSON.stringify(chartConfig))}`;
    const imageResponse = await fetch(quickChartUrl);
    const blob = await imageResponse.blob();
    const reader = new FileReader();
    const imageBase64DataUrl = await new Promise((resolve) => {
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
    const base64Pure = imageBase64DataUrl.split(',')[1];
    
    let templatePath = '/templates/ModeloExtrajudicial.docx'
    if (numImoveis === 3) {
      templatePath = '/templates/ModeloExtrajudicial3.docx';
      
    } else if (numImoveis === 4) {
      templatePath = '/templates/ModeloExtrajudicial4.docx';
    }
    else if (numImoveis === 5) {
      templatePath = '/templates/ModeloExtrajudicial.docx'
    }
    
    const response = await fetch(templatePath);
    const content = await response.arrayBuffer();
    const zip = new PizZip(content);
    const imageModule = new ImageModule({
      getImage: (tagValue) => Uint8Array.from(atob(tagValue), c => c.charCodeAt(0)),
      getSize: () => [600, 400]
    });
    
    const doc = new Docxtemplater(zip, {
      modules: [imageModule],
      paragraphLoop: true,
      linebreaks: true,
      delimiters: { start: '«', end: '»' },
    });
    
    const enderecoCompleto = [
      formData.logradouro,
      formData.numero,
      formData.complemento,
      formData.bairro,
      `${formData.cidade}/${formData.estado}`,
      `CEP ${formData.cep}`
    ].filter(Boolean).join(', ');

    formData.Endereco = enderecoCompleto;

    console.log(formData, 'formData antes de renderizar');

    try {
      doc.render({ ...formData, ...formData2, ...novoFormData, chart: base64Pure });
      setMostrarNotificacao(true)
      
    } catch (error) {
      console.error('Erro ao gerar o documento:', error);
      return;
    }

    const out = doc.getZip().generate({
      type: 'blob',
      mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    });

    saveAs(out, 'Relatorio Extrajudicail.docx');

    await salvarContribuinte()

    setSeçãoAtual(1)
    limparSelecionados()
  };





  const SelectTipoDeAreaUsada = () => (
    <div className="relative w-full lg:w-[85%] 2xl:w-[85%] md:w-[90%] sm:w-[90%] m-auto">
      <select
        name="Tipo_de_Área_Usada"
        value={formData.Tipo_de_Área_Usada}
        onChange={(e) =>
          handleChangeFormData("Tipo_de_Área_Usada", e.target.value)
        }
        className="peer w-full appearance-none rounded-xl border border-gray-300 bg-white px-4 pt-5 pb-2 pr-10 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
        <option value="" disabled hidden></option>
        <option value="Total">Total</option>
        <option value="Construída">Construída</option>
        <option value="Privativa">Privativa</option>
      </select>

      <label
        htmlFor="Tipo_de_Área_Usada"
        className="pointer-events-none absolute left-4 top-2 text-sm text-gray-500 transition-all
      peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base 
      peer-placeholder-shown:text-gray-400 peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-600"
      >
        Tipo de Área Utilizada
      </label>

      <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-gray-500">
        <svg
          className="h-4 w-4"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 11.584l3.71-4.354a.75.75 0 111.14.976l-4.25 5a.75.75 0 01-1.14 0l-4.25-5a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </div>

  );


  const SelectDetalhamentoRegional = () => (
    <div className="relative w-full lg:w-[85%] 2xl:w-[85%] md:w-[90%] sm:w-[90%] m-auto">
      <select
        name="Detalhamento_Regional"
        value={formData.Detalhamento_Regional}
        onChange={(e) =>
          handleChangeFormData("Detalhamento_Regional", e.target.value)
        }
        className="peer w-full appearance-none rounded-xl border border-gray-300 bg-white px-4 pt-5 pb-2 pr-10 text-gray-900
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
        <option value="" disabled hidden></option>
        <option value="A região tem ruas iluminadas, bom policiamento, ruas movimentadas e um clima aconchegante. Infraestrutura completa, bons colégios, hospitais, farmácias, lojas, serviços diversos,vida noturna e mobilidade urbana.">Urbana</option>
        <option value="A região tem estradas de terra, pouca movimentação e baixa densidade de população. Território atrativo à exploração extrativa agrícola, pecuária, criação de animais e outras ações voltadas ao campo da agroindústria. Além disso, a região conta com um clima aconchegante, fácil acesso para as rodovias locais, boa localização, áreas verdes e pouca concentração de construções.">Rural</option>
        <option value="A região possui trânsito descomplicado, áreas verdes, menor custo de vida, assim como promete uma rotina mais leve, com locais para lazer e maior segurança, onde se preserva os recursos naturais. Além disso, possui em suas proximidades locais para passeios, e atrativos naturais como parques ecológicos.">Imóvel Interioranos</option>
        <option value="Uma área valorizada, com praias em sua proximidade; conta com diversas opções de lazer, além de obter belezas naturais, pouca movimentação urbana e alta qualidade de vida, ótima infraestrutura, restaurantes, bares, hospitais, farmácias, lojas e, serviços diversos. Ademais, por ser um polo que atrai turistas, a prefeitura sempre se empenha em melhorar a estrutura, construindo calçadões, auxiliando no desenvolvendo do comércio, melhorando a iluminação e aumentando a segurança.">Imóveis Litorâneos</option>
      </select>

      <label
        htmlFor="Detalhamento_Regional"
        className="pointer-events-none absolute left-4 top-2 text-sm text-gray-500 transition-all
      peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base 
      peer-placeholder-shown:text-gray-400 peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-600"
      >
        Detalhamento Regional
      </label>

      <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-gray-500">
        <svg
          className="h-4 w-4"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 11.584l3.71-4.354a.75.75 0 111.14.976l-4.25 5a.75.75 0 01-1.14 0l-4.25-5a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </div>

  );


     const SelectMes = () => (
    <div className="relative w-full lg:w-[85%] 2xl:w-[85%] md:w-[90%] sm:w-[90%] m-auto">
      <select
        name="Mês"
        value={formData.Mês}
        onChange={(e) => handleChangeFormData('Mês', e.target.value)}
        className="peer w-full appearance-none rounded-xl border border-gray-300 bg-white px-4 pt-5 pb-2 text-gray-900 
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
        <option value="" disabled hidden></option>
        <option value="Janeiro">Janeiro</option>
        <option value="Fevereiro">Fevereiro</option>
        <option value="Março">Março</option>
        <option value="Abril">Abril</option>
        <option value="Maio">Maio</option>
        <option value="Junho">Junho</option>
        <option value="Julho">Julho</option>
        <option value="Agosto">Agosto</option>
        <option value="Setembro">Setembro</option>
        <option value="Outubro">Outubro</option>
        <option value="Novembro">Novembro</option>
        <option value="Dezembro">Dezembro</option>
      </select>
      <label
        htmlFor="Mês"
        className="pointer-events-none absolute left-4 top-2 text-sm text-gray-500 transition-all 
      peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base 
      peer-placeholder-shown:text-gray-400 peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-600"
      >
        Mês da Realização
      </label>
      <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-gray-500">
        <svg
          className="h-4 w-4"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06.02L10 11.584l3.71-4.354a.75.75 0 111.14.976l-4.25 5a.75.75 0 01-1.14 0l-4.25-5a.75.75 0 01.02-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </div>

  );

  return (



    <div className="w-full sm:w-3/4 md:w-[100%] 2xl:w-[40%] lg:w-[80%]  m-auto text-black relative" >
      
      <div class="text-center my-8 flex items-center justify-center flex-col">
        <h1 class="text-3xl md:text-4xl font-semibold text-gray-900">
          Relatório Extra-Judicial
        </h1>
        <p class="mt-2 text-gray-700 w-[60%] text-center ">
          Verifique se as informações estão claras, completas e corretas. Deixe suas observações, se necessário.

        </p>

      </div>

      <div className=" max-w-2xl relative mx-auto space-y-6 bg-white rounded-[20] w-[100%]">
        {confirmarLimpeza && (
          <div className='modal-overlay'>
            <div className='edit-captacao-modal !w-auto'>
              <p className='text-xl'>Deseja excluir todos os dados do formulário?</p>
              <div className='flex w-full justify-between gap-5'>
                <button onClick={() => setConfirmarLimpeza(false)} className='!bg-blue-500 flex-grow'>Cancelar</button>
                <button onClick={() => {
                  limparTudo()
                  setConfirmarLimpeza(false)
                }} className='!bg-red-500 flex-grow'>Excluir</button>
              </div>
            </div>
          </div>
        )}
      </div>
      
      {seçãoAtual == 1 && (
            <button className="absolute left-10 bottom-6 mr-12  bg-red-600 text-white px-4 py-2 mb-5 ml-5 hover:bg-red-700" onClick={() => setConfirmarLimpeza(true)}>Limpar Todo Formulário</button>
          )}


      <div className="flex space-x-4 mb-6 content-center justify-center">
        {[...Array(totalSeções)].map((_, index) => (
          <div
            key={index}
            className={`cursor-pointer text-lg font-semibold ${seçãoAtual === index + 1 ? 'text-white w-7 h-7 bg-blue-600 rounded-full text-center content-center' : 'text-white w-7 h-7 bg-gray-400 text-center rounded-full content-center'}`}
            onClick={() => setSeçãoAtual(index + 1)}
          >
            {index + 1}
          </div>
        ))}
      </div>

      <div>
        <div className="grid grid-cols-2 gap-4 w-[85%] m-auto max-sm:flex max-sm:flex-col max-sm:gap-1">
          {camposPorSeção[seçãoAtual]?.map((campo) => (
            <Input
              key={campo}
              name={campo}
              formData={formData}
              label={labels[campo]} // <-- aqui passamos o texto amigável
              handleChangeFormData={handleChangeFormData}
              setFormData={setFormData}
            />
          ))}
        </div>
        

{seçãoAtual === 2 && (
  <div className="grid grid-cols-2 gap-4 w-[85%] m-auto mt-2">
    <div className="col-span-2 flex gap-2">
      <input
        type="text"
        placeholder="CEP"
        value={formData.cep}
        onChange={(e) => handleChangeFormData("cep", e.target.value)}
        className="peer w-full rounded-xl border bg-white !px-4 !pt-5 !pb-2 text-gray-900
        focus:outline-none focus:ring-2 focus:ring-blue-500
        disabled:bg-gray-100 disabled:cursor-not-allowed placeholder:truncate"
      />
      <button
        type="button"
        onClick={async () => {
          try {
            const response = await fetch(`https://viacep.com.br/ws/${formData.cep}/json/`);
            const data = await response.json();
            if (!data.erro) {
              handleChangeFormData("logradouro", data.logradouro || "");
              handleChangeFormData("bairro", data.bairro || "");
              handleChangeFormData("cidade", data.localidade || "");
              handleChangeFormData("estado", data.uf || "");
            } else {
              alert("CEP não encontrado.");
            }
          } catch {
            alert("Erro ao buscar o CEP.");
          }
        }}
        className="rounded-xl bg-black text-white px-4 py-2 hover:bg-neutral-800 transition"
      >
        Buscar
      </button>
    </div>

    <div className="relative col-span-2">
      <input
        id="logradouro"
        type="text"
        value={formData.logradouro}
        onChange={(e) => handleChangeFormData("logradouro", e.target.value)}
        className="peer w-full rounded-xl border bg-white !px-4 !pt-5 !pb-2 text-gray-900
        focus:outline-none focus:ring-2 focus:ring-blue-500
        disabled:bg-gray-100 disabled:cursor-not-allowed placeholder:truncate"
        placeholder=" "
      />
      <label htmlFor="logradouro" className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
        peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
        w-[calc(100%-2rem)] truncate"
      >
        Logradouro
      </label>
    </div>

    <div className="relative">
      <input
        id="numero"
        type="text"
        value={formData.numero}
        onChange={(e) => handleChangeFormData("numero", e.target.value)}
        className="peer w-full rounded-xl border bg-white !px-4 !pt-5 !pb-2 text-gray-900
        focus:outline-none focus:ring-2 focus:ring-blue-500
        disabled:bg-gray-100 disabled:cursor-not-allowed placeholder:truncate"
        placeholder=" "
      />
      <label htmlFor="numero" className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
        peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
        w-[calc(100%-2rem)] truncate"
      >
        Número
      </label>
    </div>

    <div className="relative">
      <input
        id="complemento"
        type="text"
        value={formData.complemento}
        onChange={(e) => handleChangeFormData("complemento", e.target.value)}
        className="peer w-full rounded-xl border bg-white !px-4 !pt-5 !pb-2 text-gray-900
        focus:outline-none focus:ring-2 focus:ring-blue-500
        disabled:bg-gray-100 disabled:cursor-not-allowed placeholder:truncate"
        placeholder=" "
      />
      <label htmlFor="complemento" className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
        peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
        w-[calc(100%-2rem)] truncate"
      >
        Complemento
      </label>
    </div>

    <div className="relative col-span-2">
      <input
        id="bairro"
        type="text"
        value={formData.bairro}
        onChange={(e) => handleChangeFormData("bairro", e.target.value)}
        className="peer w-full rounded-xl border bg-white !px-4 !pt-5 !pb-2 text-gray-900
        focus:outline-none focus:ring-2 focus:ring-blue-500
        disabled:bg-gray-100 disabled:cursor-not-allowed placeholder:truncate"
        placeholder=" "
      />
      <label htmlFor="bairro" className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
        peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
        w-[calc(100%-2rem)] truncate"
      >
        Bairro
      </label>
    </div>

    <div className="relative">
      <input
        id="cidade"
        type="text"
        value={formData.cidade}
        onChange={(e) => handleChangeFormData("cidade", e.target.value)}
        className="peer w-full rounded-xl border bg-white !px-4 !pt-5 !pb-2 text-gray-900
        focus:outline-none focus:ring-2 focus:ring-blue-500
        disabled:bg-gray-100 disabled:cursor-not-allowed placeholder:truncate"
        placeholder=" "
      />
      <label htmlFor="cidade" className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
        peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
        w-[calc(100%-2rem)] truncate"
      >
        Cidade
      </label>
    </div>

    <div className="relative">
      <input
        id="estado"
        type="text"
        value={formData.estado}
        onChange={(e) => handleChangeFormData("estado", e.target.value)}
        className="peer w-full rounded-xl border bg-white !px-4 !pt-5 !pb-2 text-gray-900
        focus:outline-none focus:ring-2 focus:ring-blue-500
        disabled:bg-gray-100 disabled:cursor-not-allowed placeholder:truncate"
        placeholder=" "
      />
      <label htmlFor="estado" className="absolute left-4 top-2 text-sm text-gray-500 transition-all duration-200
        peer-placeholder-shown:top-5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400
        peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-500
        w-[calc(100%-2rem)] truncate"
      >
        Estado
      </label>
    </div>
  </div>
)}

        
        {seçãoAtual === 2 && <SelectMes />}
        {seçãoAtual === 2 && <SelectTipoDeAreaUsada />}
        {seçãoAtual === 3 && <SelectDetalhamentoRegional />}



      </div>

      {seçãoAtual === 4 && (



        <div className="space-y-4 w-[85%] 2x1:w-[100%] m-auto">
          <div className="relative w-[100%] m-auto">
            <input
              type="number"
              id="metros-imovel-avaliado"
              value={metrosImovelAvaliado}
              onChange={(e) => setMetrosImovelAvaliado(e.target.value)}
              placeholder=" "
              className="peer w-full rounded-xl border border-gray-300 bg-white px-4 pt-5 pb-2 text-gray-900 
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
            />
            <label
              htmlFor="metros-imovel-avaliado"
              className="pointer-events-none absolute left-4 top-2 text-sm text-gray-500 transition-all 
      peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base 
      peer-placeholder-shown:text-gray-400 peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-600"
            >
              Metros do Imóvel Avaliando
            </label>
          </div>

          <div className="relative w-[100%] m-auto">
            <select
              id="num-imoveis"
              value={numImoveis}
              onChange={(e) => {
                const novoValor = parseInt(e.target.value);
                setNumImoveis(novoValor);
                setValoresImoveis(Array(novoValor).fill(""));
                setHectares(Array(novoValor).fill(""));
              }}
              className="peer w-full appearance-none rounded-xl border border-gray-300 bg-white px-4 pt-5 pb-2 text-gray-900 
      focus:outline-none focus:ring-2 focus:ring-blue-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
            >
              <option value={3}>3 Imóveis</option>
              <option value={4}>4 Imóveis</option>
              <option value={5}>5 Imóveis</option>
            </select>

            <label
              htmlFor="num-imoveis"
              className="pointer-events-none absolute left-4 top-2 text-sm text-gray-500 transition-all
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-600
      peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400"
            >
              Número de Imóveis
            </label>

            <div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 text-gray-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>


          {[...Array(numImoveis)].map((_, index) => (
            <div key={index} className="grid grid-cols-1 md:grid-cols-3 gap-4 w-[100%] m-auto mb-4">
              {/* Valor do Imóvel */}
              <div className="relative">
                <input
                  type="number"
                  placeholder=" "
                  value={valoresImoveis[index]}
                  onChange={(e) => handleValorImovelChange(index, e.target.value)}
                  className="peer w-full appearance-none rounded-xl border border-gray-300 bg-white px-4 pt-5 pb-2 text-gray-900
        focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <label className="absolute left-4 top-2 text-sm text-gray-500 transition-all
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-600
      peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 pointer-events-none">
                  Valor do Imóvel {index + 1}
                </label>
              </div>

              {/* Metros Quadrados */}
              <div className="relative">
                <input
                  type="number"
                  placeholder=" "
                  value={hectares[index]}
                  onChange={(e) => handleMetrosQuadradosChange(index, e.target.value)}
                  className="peer w-full appearance-none rounded-xl border border-gray-300 bg-white px-4 pt-5 pb-2 text-gray-900
        focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <label className="absolute left-4 top-2 text-sm text-gray-500 transition-all
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-600
      peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 pointer-events-none">
                  Metros Quadrados {index + 1}
                </label>
              </div>

              {/* Link do Comparativo */}
              <div className="relative">
                <input
                  type="text"
                  placeholder=" "
                  value={linkComparativo[index]}
                  onChange={(e) => handleLinkComparativoChange(index, e.target.value)}
                  className="peer w-full appearance-none rounded-xl border border-gray-300 bg-white px-4 pt-5 pb-2 text-gray-900
        focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <label className="absolute left-4 top-2 text-sm text-gray-500 transition-all
      peer-focus:top-2 peer-focus:text-sm peer-focus:text-blue-600
      peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 pointer-events-none">
                  Link do Comparativo {index + 1}
                </label>
              </div>
            </div>

          ))}
        </div>
      )}



      <div className="mt-10 w[90%] p-10 flex justify-between">
        {seçãoAtual > 1 && (
          <button
            onClick={() => setSeçãoAtual(seçãoAtual - 1)}
            className="px-4 py-2 bg-gray-200 text-black rounded"
          >
            Voltar
          </button>
        )}

        {seçãoAtual < totalSeções ? (
          <>
          <p></p>
        <button
            onClick={() => setSeçãoAtual(seçãoAtual + 1)}
            className="px-4 py-2 mr-8 bg-black text-white rounded"
          >
            Próximo
          </button>

          </>
        ) : (
          <button onClick={gerarDocumento} className="px-4 py-2 bg-black text-white rounded">
            Gerar Documento
          </button>
        )}
      </div>
      <Notificacao
        mostrar={mostrarNotificacao}
        onClose={() => setMostrarNotificacao(false)}
        mensagem="Relatório Extrajudicial gerado com sucesso!"
      />
    </div>
  );

}